export async function copyToClipboard(formElement: HTMLInputElement, win: Window): Promise<void> {
  if (!win.navigator.clipboard) {
    formElement.select();
    formElement.setSelectionRange(0, 99999); // for mobile devices
    return new Promise((resolve, reject) => {
      try {
        win.document.execCommand('copy'); //NOSONAR
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }
  return win.navigator.clipboard.writeText(formElement.value);
}
